import { render, staticRenderFns } from "./FotoUpload.vue?vue&type=template&id=5d15b005"
import script from "./FotoUpload.vue?vue&type=script&lang=js"
export * from "./FotoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports